import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

export default function SimpleHelmet({
  canonicalPath,
  description,
  image,
  socialTitle,
  title,
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={socialTitle || title} />
      <meta name="twitter:title" content={socialTitle || title} />
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta name="twitter:description" content={description} />
      {!!image && <meta property="og:image" content={image} />}
      {!!image && <meta name="twitter:image" content={image} />}
      {!!canonicalPath && <link rel="canonical" href={`https://www.gasbuddy.com${canonicalPath}`} />}
    </Helmet>
  );
}

SimpleHelmet.propTypes = {
  canonicalPath: PropTypes.string,
  description: PropTypes.string.isRequired,
  image: PropTypes.string,
  socialTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
};

SimpleHelmet.defaultProps = {
  canonicalPath: undefined,
  image: undefined,
  socialTitle: undefined,
};
